"use client";

import * as React from "react";
import {
  CheckCircle2,
  Globe,
  ShieldCheck,
  Zap,
} from "lucide-react";

import { useAppStore } from "@/stores/useAppStore";
import { pushView } from "@/stores/useAppStore";
import LoginForm from "./LoginForm";
import RegisterForm from "./RegisterForm";

function BrandPanel() {
  return (
    <div className="relative hidden overflow-hidden bg-primary lg:flex lg:flex-col lg:justify-between lg:p-12">
      {/* Decorative gradient + grid */}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-primary via-primary to-emerald-700" />
      <div className="pointer-events-none absolute inset-0 bg-grid-pattern opacity-30" />
      <div
        className="pointer-events-none absolute -right-24 -top-24 size-72 rounded-full bg-white/10 blur-3xl animate-pulse-glow"
        aria-hidden
      />
      <div
        className="pointer-events-none absolute -bottom-32 -left-20 size-80 rounded-full bg-emerald-300/20 blur-3xl"
        aria-hidden
      />

      {/* Content */}
      <div className="relative z-10 flex items-center gap-3">
        <div className="flex size-12 items-center justify-center rounded-2xl bg-white/15 backdrop-blur ring-1 ring-white/30">
          <ShieldCheck className="size-7 text-white" />
        </div>
        <div>
          <p className="text-lg font-bold text-white">آکادمی فَران</p>
          <p className="text-xs text-white/80">آکادمی · هوش مصنوعی · درآمد</p>
        </div>
      </div>

      <div className="relative z-10 flex flex-col gap-6">
        <div className="flex flex-col gap-3">
          <h2 className="text-3xl font-bold leading-tight text-white">
            یاد بگیر،
            <br />
            بساز و درآمد کسب کن
          </h2>
          <p className="max-w-md text-sm leading-7 text-white/85">
            با دوره‌های تخصصی، ابزارهای آماده هوش مصنوعی و سیستم همکاری در فروش،
            مسیر رشد حرفه‌ای خود را آغاز کنید.
          </p>
        </div>

        <ul className="flex flex-col gap-3 text-sm text-white/90">
          <li className="flex items-center gap-3">
            <CheckCircle2 className="size-5 text-white" />
            دوره‌های کاربردی و پروژه‌محور
          </li>
          <li className="flex items-center gap-3">
            <Zap className="size-5 text-white" />
            ابزارهای هوش مصنوعی آماده تحویل
          </li>
          <li className="flex items-center gap-3">
            <Globe className="size-5 text-white" />
            درآمدزا از طریق معرفی کاربران
          </li>
        </ul>
      </div>

      <div className="relative z-10 text-xs text-white/70">
        © {new Date().getFullYear()} آکادمی فَران — تمامی حقوق محفوظ است.
      </div>
    </div>
  );
}

function MobileLogo() {
  return (
    <button
      type="button"
      onClick={() => pushView("landing")}
      className="flex items-center gap-3"
      aria-label="بازگشت به خانه"
    >
      <div className="flex size-11 items-center justify-center rounded-2xl bg-primary text-primary-foreground shadow-md">
        <ShieldCheck className="size-6" />
      </div>
      <div className="text-right">
        <p className="text-base font-bold leading-tight">آکادمی فَران</p>
        <p className="text-xs text-muted-foreground">آکادمی · هوش مصنوعی · درآمد</p>
      </div>
    </button>
  );
}

export default function AuthView() {
  const view = useAppStore((s) => s.view);
  const isRegister = view === "register";

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <main className="grid flex-1 lg:grid-cols-2">
        <BrandPanel />
        <div className="flex flex-col items-center justify-center px-4 py-10 sm:px-6 lg:px-12">
          <div className="mb-8 flex w-full max-w-md justify-start lg:hidden">
            <MobileLogo />
          </div>
          {isRegister ? <RegisterForm /> : <LoginForm />}
        </div>
      </main>
    </div>
  );
}
